import { CSSProperties } from "react";

type props = {
  className?: string;
  style?: CSSProperties;
};

export default function TicketIcon({ className, style }: props) {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M10.6708 1.33333H7.32914C4.17862 1.33333 2.60335 1.33333 1.62461 2.30964C0.950717 2.98186 0.740817 3.93616 0.675442 5.49122C0.662475 5.79961 0.655992 5.95382 0.713575 6.05668C0.771167 6.15956 1.00107 6.28795 1.46086 6.54475C1.97151 6.82992 2.31668 7.37475 2.31668 8C2.31668 8.62525 1.97151 9.17008 1.46086 9.45525C1.00107 9.71208 0.771167 9.84041 0.713575 9.94333C0.655992 10.0462 0.662475 10.2004 0.675442 10.5087C0.740817 12.0638 0.950717 13.0182 1.62461 13.6903C2.60335 14.6667 4.17862 14.6667 7.32914 14.6667H10.6708C13.8213 14.6667 15.3965 14.6667 16.3753 13.6903C17.0492 13.0182 17.2591 12.0638 17.3245 10.5087C17.3375 10.2004 17.344 10.0462 17.2864 9.94333C17.2288 9.84041 16.9989 9.71208 16.539 9.45525C16.0284 9.17008 15.6832 8.62525 15.6832 8C15.6832 7.37475 16.0284 6.82992 16.539 6.54475C16.9989 6.28795 17.2288 6.15956 17.2864 6.05669C17.344 5.95381 17.3375 5.79961 17.3245 5.49122C17.2591 3.93616 17.0492 2.98186 16.3753 2.30964C15.3965 1.33333 13.8213 1.33333 10.6708 1.33333Z"
        stroke="currentcolor"
      />
      <path d="M6.5 10.5L11.5 5.5" stroke="currentcolor" strokeLinecap="round" />
      <path
        d="M11.9167 10.0833C11.9167 10.5436 11.5436 10.9167 11.0833 10.9167C10.6231 10.9167 10.25 10.5436 10.25 10.0833C10.25 9.62308 10.6231 9.25 11.0833 9.25C11.5436 9.25 11.9167 9.62308 11.9167 10.0833Z"
        fill="currentcolor"
      />
      <path
        d="M7.75004 5.91667C7.75004 6.37692 7.37696 6.75 6.91671 6.75C6.45647 6.75 6.08337 6.37692 6.08337 5.91667C6.08337 5.45643 6.45647 5.08333 6.91671 5.08333C7.37696 5.08333 7.75004 5.45643 7.75004 5.91667Z"
        fill="currentcolor"
      />
    </svg>
  );
}
